/**
 * Log error to atatus
 * 
 * @param {Object} error
 * 
 * @returns {void}
 */
export async function logErrorToAtatus(error) {
    if (window.atatus) {
        window.atatus.notify(error);
    }
}
